import React from 'react';
import { WELL_EQUIPMENT_STATUS_ROWS } from '../../constants/latest-asset-trend.constant';
import GenericEspWidget from './GenericEspWidget';

const WellEquipmentStatusWidget: React.FC = () => (
  <GenericEspWidget title='Status' rowsConfig={WELL_EQUIPMENT_STATUS_ROWS} />
);

export default WellEquipmentStatusWidget;
